import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';

export const SearchBarDefaultProps = {
  ...BaseDefaultProps,
};

export const SearchBarPropTypes = {
  ...BasePropTypes,
};
